module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('model-crud', {
    attrs: {
      "model": _vm.model,
      "fields": _vm.fields,
      "editable": false,
      "deletable": false,
      "include": ['recording', 'user'],
      "fetchFilters": {
        approved: 'false'
      }
    },
    scopedSlots: _vm._u([{
      key: "_src",
      fn: function(row) {
        return [_vm._v("\n    " + _vm._s(row.item.recording.source) + "\n  ")]
      }
    }, {
      key: "_dst",
      fn: function(row) {
        return [_vm._v("\n    " + _vm._s(row.item.recording.destination) + "\n  ")]
      }
    }, {
      key: "_actions",
      fn: function(row) {
        return [_c('div', {
          staticClass: "text-xs-right no-wrap"
        }, [_c('v-btn', {
          directives: [{
            name: "tooltip",
            rawName: "v-tooltip",
            value: ({
              content: _vm.$t('audit.approve')
            }),
            expression: "{ content: $t('audit.approve') }"
          }],
          staticClass: "ma-0",
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              _vm.approve(row.item)
            }
          }
        }, [_c('v-icon', [_vm._v("done")])], 1), _vm._v(" "), _c('v-btn', {
          directives: [{
            name: "tooltip",
            rawName: "v-tooltip",
            value: ({
              content: _vm.$t('audit.deny')
            }),
            expression: "{ content: $t('audit.deny') }"
          }],
          staticClass: "ma-0",
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              _vm.deny(row.item)
            }
          }
        }, [_c('v-icon', [_vm._v("clear")])], 1)], 1)]
      }
    }])
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5ce57ca2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/RecordingRequests.vue
// module id = 1077
// module chunks = 1